import { CONSIGNMENT_ONBOARDING_TAB } from "@/core/helpers/consignmentOnboardingTab";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Curation rules live on the Onboarding page, under Curation.
export const Route = createFileRoute("/admin/consignment-curation/")({
	beforeLoad() {
		throw redirect({
			to: "/admin/consignment-onboarding",
			search: { tab: CONSIGNMENT_ONBOARDING_TAB.Curation },
			replace: true,
		});
	},
});
